import { Component, OnInit, ElementRef } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { StockService } from 'src/app/services/Stock/stock.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-purchase-order-receiving',
  templateUrl: './purchase-order-receiving.component.html',
  styleUrls: ['./purchase-order-receiving.component.css']
})
export class PurchaseOrderReceivingComponent implements OnInit {

  constructor(public ElementRef:ElementRef,private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
  currentPage = 1;
    pageSize = 20;
    recordCount = 0;
    totalPages = 0;
    numberOfPages  () {
        
        this.totalPages = Math.ceil(this.recordCount / this.pageSize);
    }

    nextPage  () {
        this.currentPage = this.currentPage + 1;

    }
    SchoolLocationList:any;
    GetSchoolLocation() {

       this.spinnerService.show();
        this.lookupService.GetLookupsList('SchoolLocation', '').subscribe( (response)=> {
            this.SchoolLocationList = response.LookupItems;
           this.spinnerService.hide();
        });
    };
    DepartmentList:any;
    GetDepartment  () {

       this.spinnerService.show();
        this.lookupService.GetLookupsList('Department', '').subscribe( (response)=> {
            this.DepartmentList = response.LookupItems;
           this.spinnerService.hide();
        });
    };
    pageSizes  () {
        this.currentPage = 1;
        this.recordCount = 0;
        this.totalPages = 0;
    }
    POReceiving :boolean= false;
    FilterModel = {
        CurrentIndex: 0,
        InventoryCategoryID:0,
        PageSize: 20,
        PONumber: '',
        FromDate: '',
        ToDate: '',
        IsRivision: 0,
        IsActive: true,
        VendorID: 0,
        POStatusID: 0
    }
    ReceivingModel = {
         AccID:0,
        PONumber: '',
        VendorID: 0,
        ReceivingDate: '',
        Remarks: '',
        ConsignmentNote: '',
        POID: 0,
        ReceivingAmount:0
    }
    ClearSearch  () {
        this.FilterModel.PONumber = '';
        this.FilterModel.FromDate = '';
        this.FilterModel.ToDate = '';
        this.FilterModel.VendorID = 0;
        this.FilterModel.POStatusID = 0;
    }
    InventoryCategoryList:any;
    GetInventoryCategory  () {
        this.lookupService.GetLookupsList('StockInventoryCategory', '').subscribe( (data)=> {
            this.InventoryCategoryList = data.LookupItems;
            this.InventoryCategoryList.splice(3, 4);
        });
    };
    ItemList = [];
    NewReceiving  (item) {
      
        this.POReceiving = true;
        this.ReceivingModel.PONumber = item.PONumber;       
        this.ReceivingModel.VendorID = item.VendorID;
        this.ReceivingModel.AccID = item.AccID;
        this.ReceivingModel.POID = item.POID;
        this.ItemList = item.ItemList;
        for (var i = 0; this.ItemList.length; i++) {
            this.ItemList[i].Total = 0;
            this.ItemList[i].ReceivingQuantity = 0;
        }
    }

    // GetSchoolLocation  () {
    //    this.spinnerService.show();
    //     this.lookupService.GetLookupsList('SchoolLocation', '').subscribe( (response)=> {
    //         this.SchoolLocationList = response.LookupItems;
    //        this.spinnerService.hide();
    //     });
    // };
    PaymentModeList:any;
    GetPaymentMode  () {
        this.lookupService.GetLookupsList('PaymentMode', '').subscribe( (data)=> {
            this.PaymentModeList = data.LookupItems;
        });
    };
    loadingAssets = true;
    AssetItemList = [];
    IsAssetsGenerate = false;
    GenerateAssets  () {
        
        this.IsAssetsGenerate = true;
        this.AssetItemList = [];
        for (var i = 0; i < this.ItemList.length; i++) {
            this.ItemList[i].Total = parseFloat(this.ItemList[i].ReceivingQuantity) * parseFloat(this.ItemList[i].UnitPrice)
            this.ItemList[i].ApprovalRemarks = '';
            if (this.ItemList[i].InventoryCategoryID == 3) {
                this.AssetItemList.push(this.ItemList[i]);
            }
        }
        setTimeout(function () {
            this.loadingAssets = false;
        }, 20);
        
    }
    ClearPOReceiving  () {
        this.POReceiving = false;
        this.ReceivingModel.PONumber = '';
        this.ReceivingModel.VendorID = 0;
        this.ReceivingModel.POID = 0;
        this.ReceivingModel.ReceivingDate = '';
        this.ReceivingModel.Remarks = '';
        this.ReceivingModel.ConsignmentNote = '';
        this.ReceivingModel.ReceivingAmount = 0;
        this.ItemList = [];
        this.AssetItemList = [];
        this.IsAssetsGenerate = false;
    }
    CalculateReceivingAmount  (index) {
        this.ReceivingModel.ReceivingAmount = 0;
        this.ItemList[index].Total = parseFloat(this.ItemList[index].ReceivingQuantity == null ? 0 : this.ItemList[index].ReceivingQuantity) * parseFloat(this.ItemList[index].UnitPrice);
        for (var i = 0; this.ItemList.length; i++) {
            this.ReceivingModel.ReceivingAmount = (this.ReceivingModel.ReceivingAmount) + (this.ItemList[i].Total);
        }
    }
    PrntPOApproval  (item) {
      // PrintPOApproval
        var url = "printpoapproval?POReceivingID=" + item.POReceivingID + "&IsActive=" + item.IsActive;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
    }
    POReceivingList = [];
    ClearReceiving  () {
        this.POReceivingList = [];
    }
    
    ViewPOReceiving  (item) {
        var filter = {
            POID:item.POID
        }
        this.stockService.GetPurchaseOrderReceiving(JSON.stringify(filter)).subscribe( (data)=> {
            this.POReceivingList = data.POReceivingList;
        });
    }
    CancelReceiving  (item) {
        var cancelmodel = {
            POReceivingID: item.POReceivingID,
            POID: item.POID,
        }
        this.spinnerService.show();
        this.stockService.CancelReceiving(JSON.stringify(cancelmodel)).subscribe( (data)=> {
            this.globalHelper.CheckActionStatus(data);
           this.spinnerService.hide();
            this.ViewPOReceiving(item);
            this.GetAllPurchaseOrder();
        });
    }
    Submitted = false;
    loading = false;
    SavePurchaseOrderReceiving  (valid) {
        this.Submitted = true;
        if (valid) {
            //if (this.IsAssetsGenerate) {
                this.loading = true;
               this.spinnerService.show();
                this.stockService.SavePurchaseOrderReceiving(JSON.stringify(this.ReceivingModel), JSON.stringify(this.ItemList), JSON.stringify(this.AssetItemList)).subscribe( (data)=> {
                    setTimeout( ()=>{
                       this.spinnerService.hide();
                        this.Submitted = false;
                        this.loading = false;
                    }, 10);
                    this.globalHelper.CheckActionStatus(data);
                    this.GetAllPurchaseOrder();
                    this.ClearPOReceiving();
                });
            //} else {
            //    alert('Please Generate assets first!');
            //}
            
        }
        
    }
    loadingsearch = false;
    POList:any;
    GetAllPurchaseOrder  () {
        this.loadingsearch = true;
        this.FilterModel.CurrentIndex = this.currentPage;
        this.FilterModel.PageSize = this.pageSize;
        this.FilterModel.IsRivision = 0;
       this.spinnerService.show();
        this.stockService.GetAllPurchaseOrderForReciving(JSON.stringify(this.FilterModel)).subscribe( (data)=> {
            this.POList = data.POList;
            this.recordCount = 0;
            if (this.POList != null && this.POList.length > 0) {
                this.recordCount = this.POList[0].RecordCount;
            }
            setTimeout( () =>{
               this.spinnerService.hide();
                this.loadingsearch = false;
            }, 10);
            this.numberOfPages();
        });
    };
    GetStatus  (IsApproved) {
        return IsApproved ? 'Yes' : 'No';
    };
    POStatusList = [];
    GetPOStatus  () {
        this.lookupService.GetLookupsList('POStatus', '').subscribe( (data)=> {
            this.POStatusList = data.LookupItems;
        });
    };
    VendorList = [];
    GetAllVendor  () {
        this.lookupService.GetLookupsList('Vendor', '').subscribe( (data)=> {
            this.VendorList = data.LookupItems;
        });
    }
   


  ngOnInit() {
       this.GetAllPurchaseOrder();
        this.GetPOStatus();
        this.GetSchoolLocation();
        this.GetDepartment();
        this.GetAllVendor();
        this.GetSchoolLocation();
        this.GetPaymentMode();
        this.GetInventoryCategory();

}
}